var _rect, _path, _path2, _path3, _path4, _circle, _rect2, _path5, _path6, _path7, _path8, _circle2, _rect3, _path9, _path0, _path1, _path10, _circle3, _rect4, _path11, _rect5, _path12, _rect6, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceYoga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 145,
    viewBox: "0 0 299 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 39,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#7CAE78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.6152 84.5387V76.3944C57.6152 75.7737 57.153 75.2501 56.5371 75.1732L47.7691 74.0771",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7695 74.0771L35.4618 84.5387",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5381 63H35.4612",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74.6923L49 63",
    stroke: "white",
    strokeWidth: 8.61539
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.69231,
    cy: 3.69231,
    r: 3.69231,
    transform: "matrix(-1 0 0 1 52.6924 53.1543)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 39,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#7CAE78"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.615 84.5387V76.3944C153.615 75.7737 153.153 75.2501 152.537 75.1732L143.769 74.0771",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.77 74.0771L131.462 84.5387",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.538 63H131.461",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145 74.6923L145 63",
    stroke: "white",
    strokeWidth: 8.61539
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.69231,
    cy: 3.69231,
    r: 3.69231,
    transform: "matrix(-1 0 0 1 148.692 53.1543)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 31,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#7CAE78"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M251.77 87.9226V77.7423C251.77 76.9664 251.192 76.3119 250.422 76.2157L239.462 74.8457",
    stroke: "white",
    strokeWidth: 4.61538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M239.462 74.8457L224.077 87.9226",
    stroke: "white",
    strokeWidth: 4.61538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M257.923 61H224.077",
    stroke: "white",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M241 75.6154L241 61",
    stroke: "white",
    strokeWidth: 10.7692
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.61538,
    cy: 4.61538,
    r: 4.61538,
    transform: "matrix(-1 0 0 1 245.615 48.6924)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M169.5 101L173.5 105L180.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 101L77.5 105L84.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 136,
    r: 2,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 16,
    r: 2,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 131.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 26.5,
    r: 1.5,
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 7.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 112.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 130.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 28.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 297.5,
    cy: 31.5,
    r: 1.5,
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M197.5 12L207.5 24.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M270.5 7L264 21",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M247 129L250.5 143",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceYoga);
export default __webpack_public_path__ + "static/media/persistence-yoga.a340b5764ad90a92efa6c91d38355a74.svg";
export { ForwardRef as ReactComponent };